import { render, staticRenderFns } from "./AlertCasePool.vue?vue&type=template&id=0618130f"
import script from "./AlertCasePool.vue?vue&type=script&lang=js"
export * from "./AlertCasePool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports